import { FaSearch } from "react-icons/fa";
import styled from "styled-components";

export const CancelPlanStyle = styled.div`
    height: 100vh;
    width: 100%;
    background-color: #E5F8FA;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`

export const WrapContent = styled.div`
    width: 85%;
    height: 80%;
    display: flex;
    flex-direction: column;
`

export const CancelPlansTitle = styled.h1`
    color: #005CA9;
    font-weight: 700;
    font-size: 45px;
    align-items: self-start;
`

export const WrapTitleAndSmallText = styled.div`
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: space-between;

    p{
        color: #428EFF;
        font-size: 15px;
        margin-top: -19px;
        margin-bottom: 20px;
        width: 450px;
    }
`

interface NewRegisterCardProps {
    isExpanded?: boolean;
  }

export const SearchContainer = styled.div<NewRegisterCardProps>`
    margin-top: 20px;
    position: relative;
    width: 98%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: ${({ isExpanded }) => (isExpanded ? "50px" : "0")};
`;

export const SearchIcon = styled(FaSearch)`
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: #005CA9;
    
    cursor: pointer;
`;

export const SearchBar = styled.input`
    position: relative;
    width: 100%;
    height: 40px;
    background-color: #FFFFFF;
    border: none;
    color: black;
    font-size: 18px;
    font-weight: 500;
    align-self: flex-start;
    padding-left: 9px;
    display: flex;
    justify-content: space-around;
    border-end-end-radius: 20px;
    border-end-start-radius: 20px;
    border-start-end-radius: 20px;
    border-start-start-radius: 20px;
    transition: all 0.3s ease;

    &:focus {
        border: 1px solid #5c8e;
        box-shadow: 0 0 8px rgba(92, 142, 200, 0.5); 
        outline: none; 
    }
`
export const Table = styled.table`
  margin-top: 20px;
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 5px;
  overflow: hidden;
`;

export const Th = styled.th`
  background-color: #E5F8FA;
  padding: 10px;
  text-align: left;
  border-bottom: 2px solid #ddd;
`;

export const Td = styled.td`
  padding: 10px;
  border-bottom: 1px solid #ddd;
`;

export const DeactivateButton = styled.button`
    align-self: flex-end;
    background-color: #FF5641;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 120px;
    padding: 8px;
    border: none;
    border-radius: 50px / 40px;
    color: #FFFFFF;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: transform 0.3s ease-in-out;

    &:hover {
        transform: scale(1.1);
    }
`

export const CancelCard = styled.div`
  width: 100%;
  min-height: 130px; 
  background-color: #F7F7F7;
  border-radius: 30px;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  position: relative; 
  cursor: pointer;
  flex-shrink: 0; 
  margin-top: 10px;

  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.2);
  }
`;

export const LeftContent = styled.div`
    display: flex;
    flex-direction: column;

    h2{
        font-size: 18px;
        font-weight: 600;
        color: black;
        margin-left: 100px;
        margin-top: 0;
        margin-bottom: 0;
    }
`

export const SelectionIndicator = styled.div<{ selected: boolean }>`
  width: 20px;
  height: 20px;
  background-color: ${({ selected }) => (selected ? "#087CDE" : "#C4C4C4")};
  border-radius: 50%;
  position: absolute;
  top: 43%;
  left: 15px;
`;

export const Select = styled.select`
  margin-left: 10px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  width: 250px;
  background: white;
  cursor: pointer;
`;

export const WrapCards = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;  
    min-height: 250px;
    max-height: 80vh; 
    overflow-y: auto;
    gap: 20px;
    width: 100%; 
`;

export const DeactivateButton2 = styled.button`
    align-self: flex-start;
    background-color: #FF5641;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 290px;
    padding: 8px;
    border: none;
    border-radius: 50px / 40px;
    color: #FFFFFF;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: transform 0.3s ease-in-out;

    &:hover {
        transform: scale(1.1);
    }
`